var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.mask ? 'the-mask' : 'input',{tag:"component",staticClass:"emd-input",class:[
        _vm.size && `_size_${_vm.size}`,
        _vm.classList
      ],attrs:{"name":_vm.name,"value":_vm.value,"minlength":_vm.minLength,"maxlength":_vm.maxLength,"id":_vm.name,"type":_vm.type,"required":_vm.required,"autofocus":_vm.autoFocus,"mask":_vm.mask,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"data-cy":_vm.dataCy},on:{"input":_vm.handleInput,"keyup":_vm.handleKeyUp}})
}
var staticRenderFns = []

export { render, staticRenderFns }